import React from 'react';
import UserIcon from "assets/img/svg/svgComponents/UserIcon";
import BankIcon from "assets/img/svg/svgComponents/BankIcon";
import PencilIcon from "assets/img/svg/svgComponents/PencilIcon";
import bankLogo from "assets/img/icons/common/bankLogo.png";
import { bankStatusChipInfo, bankStatusChipStyle, beneficiaryTypeChipStyles } from 'views/pages/manage//edpOps/studentDetails/paymentSummary/studentBankDetails/utils';
import CustomChip from 'views/pages/manage/common/customChip/CustomChip';
import styles from "views/pages/manage/edpOps/studentDetails/paymentSummary/studentBankDetails/styles.module.scss";
import { maskBankAccountNumber } from '../helper';

const BankDetailsCard = ({
    accountDetails = {},
    iconClickHandler = () => { },
    openDetailsDialogIcon = null,
    showBeneficiaryTypeChip = false
}) => {

    const { bankAccount, accountHolderName, accountType, bankKey, beneficiaryType, status, bankDetails } = accountDetails;
    return (
        <div className={`d-flex flex-column justify-content-between ${styles['bank-details-card']}`} style={{marginTop: "17px"}}>

            <div className='d-flex justify-content-between'>
                <div className={styles['bank-icon']}><img src={bankLogo} alt="bank_logo" /></div>
                {showBeneficiaryTypeChip
                    ? <CustomChip text={beneficiaryType} style={beneficiaryTypeChipStyles} />
                    : <CustomChip {...bankStatusChipInfo[status]} style={bankStatusChipStyle} />
                }
            </div>

            <div className={styles['account-no']}>{maskBankAccountNumber(bankAccount)}</div>

            <div className='d-flex justify-content-between'>
                <div className={`${styles['bank-details']}`}>
                    <div>
                        <UserIcon />
                        <span className='ml-1'>{accountHolderName} • </span>
                        <span>{accountType}</span>
                    </div>

                    <div>
                        <BankIcon />
                        <span className='ml-1'>{bankDetails?.bankId}</span>
                    </div>

                </div>

                {openDetailsDialogIcon &&
                    <span
                        className={styles['edit-icon-wrapper'] + " cursor"}
                        onClick={() => iconClickHandler(accountDetails)}
                    >
                        {openDetailsDialogIcon}
                    </span>
                }
            </div>


        </div>
    );
}

export default BankDetailsCard;